// Labels of the Latihan Ilmiah form content per "bahasa borang" — copied from idarah
// (resources/js/components/latihanIlmiah/labels.js, idarah spec §12.5).
// Only the form content switches language (spec v2 L3) — cards, buttons, statuses stay in Malay.

const LABELS = {
    ms: {
        dir: 'auto',
        title: 'Tajuk Latihan Ilmiah',
        kemajuan: 'Jadual Kemajuan Mengikut Tarikh Perjumpaan',
        no: 'Bil.',
        date: 'Tarikh',
        discussed: 'Perkara Dibincangkan',
        studentProgress: 'Tindakan / Kemajuan Pelajar',
        supervisorComment: 'Ulasan Pembimbing',
        otherNotes: 'Lain-lain catatan',
        finalComment: 'Ulasan Akhir Pembimbing',
        chapters: 'Status Bab',
    },
    ar: {
        dir: 'rtl',
        title: 'عنوان البحث',
        kemajuan: 'جدول المتابعة حسب تاريخ اللقاء',
        no: 'الرقم',
        date: 'التاريخ',
        discussed: 'الموضوعات التي نوقشت',
        studentProgress: 'إنجاز الطالب',
        supervisorComment: 'ملاحظات المشرف',
        otherNotes: 'ملاحظات أخرى',
        finalComment: 'التقرير النهائي للمشرف',
        chapters: 'حالة الفصول',
    },
}

export default function labelsFor(language) {
    return LABELS[language] || LABELS.ms
}
